import { Tooltip } from 'antd';
import type { ReactNode } from 'react';
import type { TokenAggregate } from '../../api/usage';
import { formatCreditsText } from '../../../../../libs/shared/src/billing/display';
export { formatCreditsText };

const AMOUNT_RE = /^-?(?:0|[1-9]\d*)(?:\.\d{1,6})?$/;

export function normalizeCreditAmount(value: string): string | null {
  const amount = String(value ?? '').trim();
  if (!/^(?:0|[1-9]\d{0,13})(?:\.\d{1,6})?$/.test(amount)) return null;
  const [whole, fraction = ''] = amount.split('.');
  if (whole === '0' && !/[1-9]/.test(fraction)) return null;
  return `${whole}.${(fraction + '000000').slice(0, 6)}`;
}

export function isPositiveCreditAmount(value: string): boolean {
  const amount = String(value ?? '').trim();
  if (!/^(?:0|[1-9]\d{0,13})(?:\.\d{1,6})?$/.test(amount)) return false;
  const [whole, fraction = ''] = amount.split('.');
  return !(whole === '0' && !/[1-9]/.test(fraction));
}

export function renderCredits(value: string | null | undefined, unlimited = false): ReactNode {
  const text = formatCreditsText(value, unlimited);
  if (unlimited) return text;
  if (value == null) return text;
  const node = <span className="usage-amount" tabIndex={text !== value ? 0 : undefined}>{text}</span>;
  return text !== value ? <Tooltip title={value}>{node}</Tooltip> : node;
}

function formatGrouped(value: string): string {
  const negative = value.startsWith('-');
  const raw = negative ? value.slice(1) : value;
  const [whole, fraction] = raw.split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${negative ? '-' : ''}${grouped}${fraction != null ? `.${fraction}` : ''}`;
}

export function renderToken(agg: TokenAggregate): ReactNode {
  if (agg.sum == null) return '未提供';
  const suffix = agg.reportedCount < agg.eventCount ? '（不完整）' : '';
  const text = `${agg.sum}${suffix}`;
  const compact = text.length > 12;
  const node = <span className="usage-amount">{compact ? `${formatGrouped(agg.sum)}${suffix}` : text}</span>;
  return compact ? <Tooltip title={text}>{node}</Tooltip> : node;
}

export { AMOUNT_RE };
